import { TemplateEngine } from "../../../../../../js/lib/TemplateEngine";
import { TLCEventManager } from "../../../../../../js/lib/events/EventManager";
import { LS2PAC_CONSTANTS } from "../../../../../../js/main/constants";
import { AvailabilityFactory } from "../../../../availability/AvailabilityFactory";
import { ApplicationData } from "../../../ApplicationData";
import { AvailabilityClientManager } from "../../../ClientManagers/AvailabilityClientManager";
import { LS2PacSearchDatabaseManager } from "../../../managers/SearchDatabaseManager";
import { LS2PAC_Utils } from "../../../utils/Utils";
import { LibraryThing } from "../../../widget/LibraryThingWidget";
import * as React from "react";
import { ResultButtons } from "@tlc/ls2pac/components/ResultButtons";
import { renderInShadow, renderWithoutShadow } from "@tlc/ls2pac/components/ShadowUtils";
import { RateAndReview } from "@tlc/ls2pac/components/RateAndReview";

export class BaseResultTypeView {
  constructor(options) {
    options = options || {};

    this.id = options.id;

    this.databaseConfig = options.databaseConfig;

    this.viewSupportsRatings = false;
    this.hasBoundEvents = false;
    this.resources = [];
    this.searchResponse = null;
    this.availabilityTemplate = options.availabilityTemplate;
    this.resultsTemplate = options.resultsTemplate;
    this.fetchAvailabilityOnSearchResults =
      options.fetchAvailabilityOnSearchResults || true;
    this.viewName = options.viewName;

    this.availabilitySuffix =
      options.availabilitySuffix ||
      LS2PAC_CONSTANTS.Ids.SearchPage.availabilitySuffix;
    this.footerControlsSuffix =
      options.footerControlsSuffix ||
      LS2PAC_CONSTANTS.Ids.SearchPage.footerControlsSuffix;
    this.resultItemCallAndCollSuffix =
      options.resultItemCallAndCollSuffix ||
      LS2PAC_CONSTANTS.Ids.SearchPage.resultItemCallAndColl;
  }
  renderButtons(resource) {
    const container = document.querySelector(
      `#${this.footerControlsSuffix}${resource.id}`
    );
    renderWithoutShadow(
      <ResultButtons
      onClickCheckoutDownloadable={(event) => {
        TLCEventManager.fireEvent(
          LS2PAC_CONSTANTS.Events.onAttemptEResourceCheckout,
          {
            resource,
            referrer: "Results",
          }
        );
      }}
      onClickPlaceRequest={(event) => {
        TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onRequest, {
          resource,
          referrer: "Results",
        });
      }}
        resource={resource}
        onClickAddToList={(event) => {
          TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onOpenAddToList, {
            element: $(event.currentTarget),
            resourceIds: [resource.id],
          });
        }}
      ></ResultButtons>,
      container,
      ApplicationData.language
    );
  }

  renderAvailability(resources, success) {
    resources.forEach((resource, index) => {
      if (success == false) {
        //TODO: track this?
        return;
      }

      AvailabilityFactory.displayAvailability(
        `${resource.id}${this.availabilitySuffix}`,
        resource
      );

      this.renderButtons(resource);
    });
  }
  clearResults() {
    $("#" + this.id).empty();
  }
  refreshAvailability() {
    var _this = this;
    if (this.isCurrentResultTypeView()) {
      if (_this.fetchAvailabilityOnSearchResults) {
        if (window.isIE8 == false) {
          $("#" + _this.id)
            .find(".availabilityLink")
            .spin("tiny");
        }
        AvailabilityClientManager.getItemAvailability(
          _this.resources,
          function (resources, wentToServer, success) {
            _this.renderAvailability(_this.resources, success);
          }
        );
      }
    }
  }
  loadResults(event) {
    var _this = this;
    this.searchResponse = event.data;

    //TODO: throw away code
    window.currentPage = event.data.currentPage;

    if (this.isCurrentResultTypeView()) {
      $("#" + LS2PAC_CONSTANTS.Ids.FlowViewPage.flowViewItemContainer).hide();

      this.resources = event.data.resources;

      if (event.success) {
        TemplateEngine.fetch(
          _this.resultsTemplate,
          $("#" + _this.id),
          _this.resources,
          function () {
            _this.refreshAvailability();

            $.each(_this.resources, function (index, resource) {
              $(
                "#" +
                  resource.id +
                  LS2PAC_CONSTANTS.Ids.SearchPage.bookJacketSuffix
              ).addCoverArt(
                LibraryThing.enums.requestType.bookJacketSmall,
                _this.resources,
                index,
                true
              );

              if (resource.ratingInformation && _this.viewSupportsRatings) {
                const { resourceId, average, onClickReview } =
                  LS2PAC_Utils.getRatingsConfiguration(resource);
                const container = document.querySelector(
                  "#" +
                    LS2PAC_CONSTANTS.Ids.SearchPage.ratingsSuffix +
                    resource.id
                );
                renderInShadow(
                  <RateAndReview
                    resourceId={resourceId}
                    averageRating={average}
                    onClickReview={onClickReview}
                  ></RateAndReview>,
                  container,
                  ApplicationData.language
                );
              }
            });
          },
          TemplateEngine.method.overwrite
        );
      } else {
        $("#" + this.id).empty();
      }
    }
  }
  openQuickInfo(quickInfoType) {
    var _this = this;
    return function (event) {
      var link = $(event.currentTarget),
        index = parseInt(link.attr("data-index"), 10),
        resource = _this.resources[index],
        parent = $(
          "#" + LS2PAC_CONSTANTS.Ids.SearchPage.result_resource_prefix + index
        );

      TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onQuickInfo, {
        resource: resource,
        parentElement: parent,
        index: index,
        quickInfoType: quickInfoType,
      });
    };
  }
  addListeners() {
    //must be here
  }
  addExtraListeners() {}
  addEvents() {}
  isCurrentResultTypeView() {
    return this.viewName == ApplicationData.getCurrentResultsView();
  }
  isCurrent() {
    return (
      this.databaseConfig.databaseKey ===
      LS2PacSearchDatabaseManager.getCurrentDatabaseKey()
    );
  }
}
